import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

import Layout from "../../../components/Layout";
import { getUserMeEvents } from "../../../api/user/me";

const DashboardLayout = ({ id, children }) => {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const decoded = jwtDecode(localStorage.getItem("auth"));
  const [events, setEvents] = useState([]);

  useEffect(() => {
    if (decoded?.type !== "event-admin") {
      window.location.replace("/");
    }
  }, [decoded]);

  useEffect(() => {
    getUserMeEvents().then((res) => {
      const data = res?.data;
      setEvents(data);
    });
  }, []);

  const SidebarNav = () => (
    <nav className="space-y-2 mt-6">
      <NavLink
        to={`/dashboard/${id}`}
        end
        className={({ isActive }) =>
          `block px-4 py-2 rounded ${isActive ? "bg-gray-900" : "hover:bg-gray-800"}`
        }
      >
        📊 Statistika
      </NavLink>
      <NavLink
        to={`/dashboard/${id}/tickets`}
        className={({ isActive }) =>
          `block px-4 py-2 rounded ${isActive ? "bg-gray-900" : "hover:bg-gray-800"}`
        }
      >
        📄 Biletlər
      </NavLink>
      <NavLink
        to={`/dashboard/${id}/ticket-types`}
        className={({ isActive }) =>
          `block px-4 py-2 rounded ${isActive ? "bg-gray-900" : "hover:bg-gray-800"}`
        }
      >
        🎟️ Bilet Növləri
      </NavLink>
      <NavLink
        to={`/dashboard/${id}/settings`}
        className={({ isActive }) =>
          `block px-4 py-2 rounded ${isActive ? "bg-gray-900" : "hover:bg-gray-800"}`
        }
      >
        ⚙️ Parametrlər
      </NavLink>
    </nav>
  );

  const Sidebar = (
    <div className="w-64 bg-black text-white p-6 space-y-4 h-full">
      <h2 className="text-2xl font-bold mb-4">Tədbir Paneli</h2>
      <select
        className="w-full border border-gray-300 rounded-lg p-3 bg-white text-black focus:outline-none focus:ring-2 focus:ring-black"
        onChange={(e) => {
          navigate(`/dashboard/${e.target.value}`);
          setSidebarOpen(false);
        }}
        value={id}
      >
        <option value="">Tədbir seç</option>
        {events?.map(({ _id, title }) => (
          <option key={_id} value={_id}>
            {title}
          </option>
        ))}
      </select>
      {id && <SidebarNav />}
    </div>
  );

  const nav = <>
    {/* 🚀 Tədbirə Keç Düyməsi */}
      { id && (
        <div>
          <button
            onClick={() => navigate(`/events/${id}`)}
            className="bg-white text-black border border-black px-4 py-2 rounded-lg shadow hover:bg-black hover:text-white hover:border-white transition duration-200 text-xs md:text-base"
          >
            🚀 Tədbirə Keç
          </button>
        </div>
      )}
      {/* Hamburger for Mobile */}
      <div className="md:hidden">
        <button
          onClick={() => setSidebarOpen(!sidebarOpen)}
          className="bg-black text-white px-2 py-1 rounded-lg shadow-md border border-white focus:outline-none"
        >
          ☰
        </button>
      </div>
  </>

  return (
    <Layout nav={nav}>
      <div className="flex min-h-screen relative">
        {/* Sidebar for Mobile */}
        <div
          className={`fixed inset-0 z-20 transition-transform transform duration-300 ease-in-out ${
            sidebarOpen ? "translate-x-0" : "-translate-x-full"
          } md:hidden flex`}
        >
          {/* Overlay */}
          <div
            className="absolute inset-0 bg-black bg-opacity-50"
            onClick={() => setSidebarOpen(false)}
          ></div>

          {/* Sidebar content */}
          <div className="relative z-30 h-full">{Sidebar}</div>
        </div>

        {/* Sidebar for Desktop */}
        <aside className="hidden md:block">{Sidebar}</aside>

        {/* Main Content */}
        {id && (
          <main className="flex-1 bg-gray-100 p-6 md:p-10 w-full">
            {children}
          </main>
        )}
      </div>
    </Layout>
  );
};

export default DashboardLayout;
